var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-dialog",
    {
      attrs: { width: "600" },
      model: {
        value: _vm.authorityGroupDialogVisible,
        callback: function ($$v) {
          _vm.authorityGroupDialogVisible = $$v
        },
        expression: "authorityGroupDialogVisible",
      },
    },
    [
      _c("customDialog", {
        scopedSlots: _vm._u([
          {
            key: "title",
            fn: function () {
              return [
                _vm._v(
                  " " +
                    _vm._s(
                      _vm.isUserAuthorityDetail
                        ? _vm.t("userInformation")
                        : _vm.privilegeGroupData.id != undefined
                        ? _vm.t("editAuthGroup")
                        : _vm.t("newGroupCreate")
                    ) +
                    " "
                ),
                _c("button", { attrs: { id: "dialog_exit" } }, [
                  _c("img", {
                    attrs: {
                      src: require("@/assets/images/popup_close.png"),
                      id: "btn_img",
                    },
                    on: {
                      click: function ($event) {
                        _vm.authorityGroupDialogVisible = false
                      },
                    },
                  }),
                ]),
              ]
            },
            proxy: true,
          },
          {
            key: "body",
            fn: function () {
              return [
                _c(
                  "v-row",
                  { staticClass: "ma-0 pa-0", attrs: { justify: "center" } },
                  [
                    _c(
                      "v-col",
                      {
                        staticClass: "ma-0 pa-0",
                        attrs: { id: "dialog_body", cols: "10" },
                      },
                      [
                        _vm.isUserAuthorityDetail == true
                          ? _c(
                              "v-row",
                              {
                                staticClass: "ma-0 pa-0 user_detail_list",
                                attrs: { justify: "space-between" },
                              },
                              [
                                _c(
                                  "v-col",
                                  {
                                    staticClass: "ma-0 pa-0",
                                    attrs: { cols: "auto" },
                                  },
                                  [_vm._v(_vm._s(_vm.t("name")) + " :")]
                                ),
                                _c(
                                  "v-col",
                                  {
                                    staticClass: "ma-0 pa-0",
                                    attrs: { cols: "auto" },
                                  },
                                  [_vm._v(_vm._s(_vm.userAuthorityDetail.name))]
                                ),
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm.isUserAuthorityDetail == true
                          ? _c(
                              "v-row",
                              {
                                staticClass: "ma-0 pa-0 user_detail_list",
                                attrs: { justify: "space-between" },
                              },
                              [
                                _c(
                                  "v-col",
                                  {
                                    staticClass: "ma-0 pa-0",
                                    attrs: { cols: "auto" },
                                  },
                                  [_vm._v(_vm._s(_vm.t("userId")) + " :")]
                                ),
                                _c(
                                  "v-col",
                                  {
                                    staticClass: "ma-0 pa-0",
                                    attrs: { cols: "auto" },
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(_vm.userAuthorityDetail.userName)
                                    ),
                                  ]
                                ),
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm.isUserAuthorityDetail == true
                          ? _c(
                              "v-row",
                              {
                                staticClass: "ma-0 pa-0 user_detail_list",
                                attrs: { justify: "space-between" },
                              },
                              [
                                _c(
                                  "v-col",
                                  {
                                    staticClass: "ma-0 pa-0",
                                    attrs: { cols: "auto" },
                                  },
                                  [_vm._v(_vm._s(_vm.t("emailAddress")) + " :")]
                                ),
                                _c(
                                  "v-col",
                                  {
                                    staticClass: "ma-0 pa-0",
                                    attrs: { cols: "auto" },
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.userAuthorityDetail.mailAddress
                                      )
                                    ),
                                  ]
                                ),
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm.isUserAuthorityDetail == true
                          ? _c(
                              "v-row",
                              {
                                staticClass: "ma-0 pa-0 user_detail_list",
                                attrs: { justify: "space-between" },
                              },
                              [
                                _c(
                                  "v-col",
                                  {
                                    staticClass: "ma-0 pa-0",
                                    attrs: {
                                      cols: "auto",
                                      "align-self": "center",
                                    },
                                  },
                                  [_vm._v(_vm._s(_vm.t("authority")) + " :")]
                                ),
                                _c(
                                  "v-col",
                                  {
                                    staticClass: "ma-0 pa-0",
                                    attrs: { cols: "auto" },
                                  },
                                  [
                                    _c(
                                      "v-row",
                                      {
                                        staticClass: "ma-0 pa-0",
                                        attrs: { cols: "auto" },
                                      },
                                      [
                                        _c(
                                          "v-col",
                                          {
                                            staticClass: "ma-0 pa-0 mr-2",
                                            attrs: {
                                              cols: "auto",
                                              "align-self": "center",
                                            },
                                          },
                                          [_vm._v(_vm._s(_vm.ts("normalUser")))]
                                        ),
                                        _c(
                                          "v-col",
                                          {
                                            staticClass: "ma-0 pa-0",
                                            staticStyle: { width: "10rem" },
                                            attrs: { cols: "auto" },
                                          },
                                          [
                                            _c("v-select", {
                                              staticClass: "ma-0 pa-1",
                                              attrs: {
                                                placeholder: "グループ未設定",
                                                items: _vm.privilegeGroupList,
                                                dense: "",
                                                "hide-details": "",
                                                outlined: "",
                                                dark: "",
                                                "item-text": "name",
                                                "item-value": "id",
                                              },
                                              model: {
                                                value: _vm.selectedAuthority,
                                                callback: function ($$v) {
                                                  _vm.selectedAuthority = $$v
                                                },
                                                expression: "selectedAuthority",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm.isUserAuthorityDetail != true
                          ? _c(
                              "v-row",
                              {
                                staticClass: "ma-0 pa-0 mb-15 user_detail_list",
                                attrs: { justify: "space-between" },
                              },
                              [
                                _c(
                                  "v-col",
                                  {
                                    staticClass: "ma-0 pa-0",
                                    attrs: {
                                      cols: "auto",
                                      "align-self": "center",
                                    },
                                  },
                                  [_vm._v(_vm._s(_vm.t("authorityGroupName")))]
                                ),
                                _c(
                                  "v-col",
                                  {
                                    staticClass: "ma-0 pa-0",
                                    attrs: { cols: "auto" },
                                  },
                                  [
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.groupName,
                                          expression: "groupName",
                                        },
                                      ],
                                      attrs: {
                                        id: "name_input",
                                        placeholder: _vm.t(
                                          "groupNamePlaceholder"
                                        ),
                                      },
                                      domProps: { value: _vm.groupName },
                                      on: {
                                        input: function ($event) {
                                          if ($event.target.composing) {
                                            return
                                          }
                                          _vm.groupName = $event.target.value
                                        },
                                      },
                                    }),
                                  ]
                                ),
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm.roleNumber != "0" &&
                        _vm.roleNumber != "1" &&
                        _vm.roleNumber != "30" &&
                        _vm.roleNumber != "31" &&
                        _vm.currentRole != "main" &&
                        _vm.currentRole != "head"
                          ? _c(
                              "v-row",
                              { staticClass: "ma-0 pa-0 user_detail_group" },
                              [
                                _vm._v(
                                  " " + _vm._s(_vm.t("settingSystem")) + " "
                                ),
                              ]
                            )
                          : _vm._e(),
                        _vm.roleNumber != "0" &&
                        _vm.roleNumber != "1" &&
                        _vm.roleNumber != "30" &&
                        _vm.roleNumber != "31" &&
                        _vm.currentRole != "main" &&
                        _vm.currentRole != "head"
                          ? _c(
                              "v-row",
                              {
                                staticClass: "ma-0 pa-0 user_detail_list",
                                attrs: { justify: "space-between" },
                              },
                              [
                                _c(
                                  "v-col",
                                  {
                                    staticClass: "ma-0 pa-0",
                                    attrs: { cols: "auto" },
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.t(
                                          "settingFeaturesForPermissionGroups"
                                        )
                                      )
                                    ),
                                  ]
                                ),
                                _c(
                                  "v-col",
                                  {
                                    staticClass: "ma-0 pa-0",
                                    attrs: { cols: "auto" },
                                  },
                                  [
                                    _c("v-switch", {
                                      staticClass: "ma-0 pa-0",
                                      attrs: {
                                        disabled:
                                          _vm.disableList.indexOf(
                                            _vm.accountRole
                                              .SET_PERMISSIONS_GROUP
                                          ) != -1,
                                        "hide-details": "",
                                      },
                                      model: {
                                        value:
                                          _vm.accountAuthGroup
                                            .SET_PERMISSIONS_GROUP,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.accountAuthGroup,
                                            "SET_PERMISSIONS_GROUP",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "accountAuthGroup.SET_PERMISSIONS_GROUP",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm.roleNumber != 2 &&
                        _vm.roleNumber != 3 &&
                        _vm.roleNumber != 9 &&
                        _vm.roleNumber != 32 &&
                        _vm.roleNumber != 33 &&
                        _vm.roleNumber != 39
                          ? _c(
                              "v-row",
                              {
                                staticClass:
                                  "ma-0 pa-0 mt-15 user_detail_group",
                              },
                              [
                                _vm._v(
                                  " " + _vm._s(_vm.t("analyticalData")) + " "
                                ),
                              ]
                            )
                          : _vm._e(),
                        _vm.currentRole != "branch" &&
                        _vm.currentRole != "private"
                          ? _c(
                              "v-row",
                              {
                                staticClass: "ma-0 pa-0 user_detail_list",
                                attrs: { justify: "space-between" },
                              },
                              [
                                _c(
                                  "v-col",
                                  {
                                    staticClass: "ma-0 pa-0",
                                    attrs: { cols: "auto" },
                                  },
                                  [_vm._v(_vm._s(_vm.t("storeGroup")))]
                                ),
                                _c(
                                  "v-col",
                                  {
                                    staticClass: "ma-0 pa-0",
                                    attrs: { cols: "auto" },
                                  },
                                  [
                                    _c("v-switch", {
                                      staticClass: "ma-0 pa-0",
                                      attrs: {
                                        disabled:
                                          _vm.disableList.indexOf(
                                            _vm.accountRole.GET_STORE_GROUP
                                          ) != -1,
                                        "hide-details": "",
                                      },
                                      model: {
                                        value:
                                          _vm.accountAuthGroup.GET_STORE_GROUP,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.accountAuthGroup,
                                            "GET_STORE_GROUP",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "accountAuthGroup.GET_STORE_GROUP",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm.roleNumber == "0" ||
                        _vm.roleNumber == "1" ||
                        _vm.roleNumber == "30" ||
                        _vm.roleNumber == "31"
                          ? _c(
                              "v-row",
                              {
                                staticClass: "ma-0 pa-0 user_detail_list",
                                attrs: { justify: "space-between" },
                              },
                              [
                                _c(
                                  "v-col",
                                  {
                                    staticClass: "ma-0 pa-0",
                                    attrs: { cols: "auto" },
                                  },
                                  [_vm._v(_vm._s(_vm.t("ownStore")))]
                                ),
                                _c(
                                  "v-col",
                                  {
                                    staticClass: "ma-0 pa-0",
                                    attrs: { cols: "auto" },
                                  },
                                  [
                                    _c("v-switch", {
                                      staticClass: "ma-0 pa-0",
                                      attrs: { "hide-details": "" },
                                      model: {
                                        value:
                                          _vm.accountAuthGroup.GET_OWN_STORE,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.accountAuthGroup,
                                            "GET_OWN_STORE",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "accountAuthGroup.GET_OWN_STORE",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm.currentRole != "branch" &&
                        _vm.currentRole != "private"
                          ? _c(
                              "v-row",
                              {
                                staticClass:
                                  "ma-0 pa-0 mt-15 user_detail_group",
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(_vm.t("functionalExpression")) +
                                    " "
                                ),
                              ]
                            )
                          : _vm._e(),
                        _vm.currentRole != "branch" &&
                        _vm.currentRole != "private"
                          ? _c(
                              "v-row",
                              {
                                staticClass: "ma-0 pa-0 user_detail_list",
                                attrs: { justify: "space-between" },
                              },
                              [
                                _c(
                                  "v-col",
                                  {
                                    staticClass: "ma-0 pa-0",
                                    attrs: { cols: "auto" },
                                  },
                                  [_vm._v(_vm._s(_vm.t("dashboard")))]
                                ),
                                _c(
                                  "v-col",
                                  {
                                    staticClass: "ma-0 pa-0",
                                    attrs: { cols: "auto" },
                                  },
                                  [
                                    _c("v-switch", {
                                      staticClass: "ma-0 pa-0",
                                      attrs: {
                                        disabled:
                                          _vm.disableList.indexOf(
                                            _vm.accountRole.GET_DASHBOARD
                                          ) != -1,
                                        "hide-details": "",
                                      },
                                      model: {
                                        value:
                                          _vm.accountAuthGroup.GET_DASHBOARD,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.accountAuthGroup,
                                            "GET_DASHBOARD",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "accountAuthGroup.GET_DASHBOARD",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            )
                          : _vm._e(),
                        _c(
                          "v-row",
                          { staticClass: "ma-0 pa-0 mt-15 user_detail_group" },
                          [_vm._v(" " + _vm._s(_vm.t("operatingSystem")) + " ")]
                        ),
                        _c(
                          "v-row",
                          {
                            staticClass: "ma-0 pa-0 user_detail_list",
                            attrs: { justify: "space-between" },
                          },
                          [
                            _c(
                              "v-col",
                              {
                                staticClass: "ma-0 pa-0",
                                attrs: { cols: "auto" },
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.t("bookmarkCreationAndNotification")
                                  )
                                ),
                              ]
                            ),
                            _c(
                              "v-col",
                              {
                                staticClass: "ma-0 pa-0",
                                attrs: { cols: "auto" },
                              },
                              [
                                _c("v-switch", {
                                  staticClass: "ma-0 pa-0",
                                  attrs: {
                                    disabled:
                                      _vm.disableList.indexOf(
                                        _vm.accountRole.ADD_BOOKMARK
                                      ) != -1,
                                    "hide-details": "",
                                  },
                                  model: {
                                    value: _vm.accountAuthGroup.ADD_BOOKMARK,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.accountAuthGroup,
                                        "ADD_BOOKMARK",
                                        $$v
                                      )
                                    },
                                    expression: "accountAuthGroup.ADD_BOOKMARK",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "v-row",
                          {
                            staticClass: "ma-0 pa-0 user_detail_list",
                            attrs: { justify: "space-between" },
                          },
                          [
                            _c(
                              "v-col",
                              {
                                staticClass: "ma-0 pa-0",
                                attrs: { cols: "auto" },
                              },
                              [
                                _vm._v(
                                  _vm._s(_vm.t("clipCreationAndNotification"))
                                ),
                              ]
                            ),
                            _c(
                              "v-col",
                              {
                                staticClass: "ma-0 pa-0",
                                attrs: { cols: "auto" },
                              },
                              [
                                _c("v-switch", {
                                  staticClass: "ma-0 pa-0",
                                  attrs: {
                                    disabled:
                                      _vm.disableList.indexOf(
                                        _vm.accountRole.ADD_CLIP
                                      ) != -1,
                                    "hide-details": "",
                                  },
                                  model: {
                                    value: _vm.accountAuthGroup.ADD_CLIP,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.accountAuthGroup,
                                        "ADD_CLIP",
                                        $$v
                                      )
                                    },
                                    expression: "accountAuthGroup.ADD_CLIP",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "v-row",
                          {
                            staticClass: "ma-0 pa-0 user_detail_list",
                            attrs: { justify: "space-between" },
                          },
                          [
                            _c(
                              "v-col",
                              {
                                staticClass: "ma-0 pa-0",
                                attrs: { cols: "auto" },
                              },
                              [_vm._v(_vm._s(_vm.t("tagSetting")))]
                            ),
                            _c(
                              "v-col",
                              {
                                staticClass: "ma-0 pa-0",
                                attrs: { cols: "auto" },
                              },
                              [
                                _c("v-switch", {
                                  staticClass: "ma-0 pa-0",
                                  attrs: {
                                    disabled:
                                      _vm.disableList.indexOf(
                                        _vm.accountRole.SET_TAG
                                      ) != -1,
                                    "hide-details": "",
                                  },
                                  model: {
                                    value: _vm.accountAuthGroup.SET_TAG,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.accountAuthGroup,
                                        "SET_TAG",
                                        $$v
                                      )
                                    },
                                    expression: "accountAuthGroup.SET_TAG",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "v-row",
                          {
                            staticClass: "ma-0 pa-0 user_detail_list",
                            attrs: { justify: "space-between" },
                          },
                          [
                            _c(
                              "v-col",
                              {
                                staticClass: "ma-0 pa-0",
                                attrs: { cols: "auto" },
                              },
                              [_vm._v(_vm._s(_vm.t("cameraSettings")))]
                            ),
                            _c(
                              "v-col",
                              {
                                staticClass: "ma-0 pa-0",
                                attrs: { cols: "auto" },
                              },
                              [
                                _c("v-switch", {
                                  staticClass: "ma-0 pa-0",
                                  attrs: {
                                    disabled:
                                      _vm.disableList.indexOf(
                                        _vm.accountRole.SET_CAMERA
                                      ) != -1,
                                    "hide-details": "",
                                  },
                                  model: {
                                    value: _vm.accountAuthGroup.SET_CAMERA,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.accountAuthGroup,
                                        "SET_CAMERA",
                                        $$v
                                      )
                                    },
                                    expression: "accountAuthGroup.SET_CAMERA",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "v-row",
                          {
                            staticClass: "ma-0 pa-0 user_detail_list",
                            attrs: { justify: "space-between" },
                          },
                          [
                            _c(
                              "v-col",
                              {
                                staticClass: "ma-0 pa-0",
                                attrs: { cols: "auto" },
                              },
                              [_vm._v(_vm._s(_vm.t("logoutTimeSetting")))]
                            ),
                            _c(
                              "v-col",
                              {
                                staticClass: "ma-0 pa-0",
                                attrs: { cols: "auto" },
                              },
                              [
                                _c("v-switch", {
                                  staticClass: "ma-0 pa-0",
                                  attrs: {
                                    disabled:
                                      _vm.disableList.indexOf(
                                        _vm.accountRole.SET_LOGOUT_TIME
                                      ) != -1,
                                    "hide-details": "",
                                  },
                                  model: {
                                    value: _vm.accountAuthGroup.SET_LOGOUT_TIME,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.accountAuthGroup,
                                        "SET_LOGOUT_TIME",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "accountAuthGroup.SET_LOGOUT_TIME",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "v-row",
                          {
                            staticClass: "ma-0 pa-0 user_detail_list",
                            attrs: { justify: "space-between" },
                          },
                          [
                            _c(
                              "v-col",
                              {
                                staticClass: "ma-0 pa-0",
                                attrs: { cols: "auto" },
                              },
                              [_vm._v(_vm._s(_vm.t("stopRecording")))]
                            ),
                            _c(
                              "v-col",
                              {
                                staticClass: "ma-0 pa-0",
                                attrs: { cols: "auto" },
                              },
                              [
                                _c("v-switch", {
                                  staticClass: "ma-0 pa-0",
                                  attrs: {
                                    disabled:
                                      _vm.disableList.indexOf(
                                        _vm.accountRole.SET_RECORDING
                                      ) != -1,
                                    "hide-details": "",
                                  },
                                  model: {
                                    value: _vm.accountAuthGroup.SET_RECORDING,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.accountAuthGroup,
                                        "SET_RECORDING",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "accountAuthGroup.SET_RECORDING",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "v-row",
                          { staticClass: "ma-0 pa-0 mt-15 user_detail_group" },
                          [_vm._v(" " + _vm._s(_vm.t("browsingSystem")) + " ")]
                        ),
                        _c(
                          "v-row",
                          {
                            staticClass:
                              "ma-0 pa-0 user_detail_list disabled_div",
                            attrs: { justify: "space-between" },
                          },
                          [
                            _c(
                              "v-col",
                              {
                                staticClass: "ma-0 pa-0",
                                attrs: { cols: "auto" },
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.t(
                                      "liveVideoViewingRecordingAndPlayback"
                                    )
                                  )
                                ),
                              ]
                            ),
                            _c(
                              "v-col",
                              {
                                staticClass: "ma-0 pa-0",
                                attrs: { cols: "auto" },
                              },
                              [
                                _c("v-switch", {
                                  staticClass: "ma-0 pa-0",
                                  attrs: { disabled: "", "hide-details": "" },
                                  model: {
                                    value: _vm.accountAuthGroup.GET_RECORDING,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.accountAuthGroup,
                                        "GET_RECORDING",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "accountAuthGroup.GET_RECORDING",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "v-row",
                          {
                            staticClass: "ma-0 pa-0 user_detail_list",
                            attrs: { justify: "space-between" },
                          },
                          [
                            _c(
                              "v-col",
                              {
                                staticClass: "ma-0 pa-0",
                                attrs: { cols: "auto" },
                              },
                              [_vm._v(_vm._s(_vm.t("downloadRecordedData")))]
                            ),
                            _vm.currentRole == "private" ||
                            _vm.currentRole == "branch"
                              ? _c(
                                  "v-col",
                                  {
                                    staticClass: "ma-0 pa-0",
                                    attrs: { cols: "auto" },
                                  },
                                  [
                                    _c("v-switch", {
                                      staticClass: "ma-0 pa-0",
                                      attrs: {
                                        disabled:
                                          _vm.disableList.indexOf(
                                            _vm.accountRole.DOWNLOAD_RECORDING
                                          ) != -1,
                                        "hide-details": "",
                                      },
                                      model: {
                                        value:
                                          _vm.accountAuthGroup
                                            .DOWNLOAD_RECORDING,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.accountAuthGroup,
                                            "DOWNLOAD_RECORDING",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "accountAuthGroup.DOWNLOAD_RECORDING",
                                      },
                                    }),
                                  ],
                                  1
                                )
                              : _c(
                                  "v-col",
                                  {
                                    staticClass: "ma-0 pa-0",
                                    attrs: { cols: "auto" },
                                  },
                                  [
                                    _c("v-switch", {
                                      staticClass: "ma-0 pa-0",
                                      attrs: {
                                        disabled:
                                          _vm.disableList.indexOf(
                                            _vm.accountRole
                                              .DOWNLOAD_RECORDING_SUB_BRANCH
                                          ) != -1,
                                        "hide-details": "",
                                      },
                                      model: {
                                        value:
                                          _vm.accountAuthGroup
                                            .DOWNLOAD_RECORDING_SUB_BRANCH,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.accountAuthGroup,
                                            "DOWNLOAD_RECORDING_SUB_BRANCH",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "accountAuthGroup.DOWNLOAD_RECORDING_SUB_BRANCH",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                          ],
                          1
                        ),
                        _c(
                          "v-row",
                          {
                            staticClass: "ma-0 pa-0 user_detail_list",
                            attrs: { justify: "space-between" },
                          },
                          [
                            _c(
                              "v-col",
                              {
                                staticClass: "ma-0 pa-0",
                                attrs: { cols: "auto" },
                              },
                              [_vm._v(_vm._s(_vm.t("ptzOperation")))]
                            ),
                            _vm.role === "main" || _vm.role === "head"
                              ? _c(
                                  "v-col",
                                  {
                                    staticClass: "ma-0 pa-0",
                                    attrs: { cols: "auto" },
                                  },
                                  [
                                    _c("v-switch", {
                                      staticClass: "ma-0 pa-0",
                                      attrs: {
                                        disabled:
                                          _vm.disableList.indexOf(
                                            _vm.accountRole.SET_PTZ_SUB_BRANCH
                                          ) != -1,
                                        "hide-details": "",
                                      },
                                      model: {
                                        value:
                                          _vm.accountAuthGroup
                                            .SET_PTZ_SUB_BRANCH,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.accountAuthGroup,
                                            "SET_PTZ_SUB_BRANCH",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "accountAuthGroup.SET_PTZ_SUB_BRANCH",
                                      },
                                    }),
                                  ],
                                  1
                                )
                              : _c(
                                  "v-col",
                                  {
                                    staticClass: "ma-0 pa-0",
                                    attrs: { cols: "auto" },
                                  },
                                  [
                                    _c("v-switch", {
                                      staticClass: "ma-0 pa-0",
                                      attrs: {
                                        disabled:
                                          _vm.disableList.indexOf(
                                            _vm.accountRole.SET_PTZ
                                          ) != -1,
                                        "hide-details": "",
                                      },
                                      model: {
                                        value: _vm.accountAuthGroup.SET_PTZ,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.accountAuthGroup,
                                            "SET_PTZ",
                                            $$v
                                          )
                                        },
                                        expression: "accountAuthGroup.SET_PTZ",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                          ],
                          1
                        ),
                        _c(
                          "v-row",
                          {
                            staticClass: "ma-0 pa-0 mt-15 pb-2 justify-center",
                          },
                          [
                            _c(
                              "v-btn",
                              {
                                staticClass: "ma-0 pa-0 ml-2",
                                attrs: {
                                  id: "grey_btn",
                                  width: "10rem",
                                  height: "2rem",
                                },
                                on: {
                                  click: function ($event) {
                                    _vm.authorityGroupDialogVisible = false
                                  },
                                },
                              },
                              [_vm._v(_vm._s(_vm.t("cancel")))]
                            ),
                            _vm.isUserAuthorityDetail == true
                              ? _c(
                                  "v-btn",
                                  {
                                    staticClass: "ma-0 pa-0 ml-2",
                                    attrs: {
                                      id: "blue_btn",
                                      loading: _vm.loading,
                                      width: "10rem",
                                      height: "2rem",
                                    },
                                    on: { click: _vm.addAccountAuthGroup },
                                  },
                                  [_vm._v(_vm._s(_vm.t("changePermissions")))]
                                )
                              : _vm.privilegeGroupData.id != undefined
                              ? _c(
                                  "v-btn",
                                  {
                                    staticClass: "ma-0 pa-0 ml-2",
                                    attrs: {
                                      id: "blue_btn",
                                      loading: _vm.loading,
                                      width: "10rem",
                                      height: "2rem",
                                    },
                                    on: { click: _vm.patchUserGroupAuthGroup },
                                  },
                                  [_vm._v(_vm._s(_vm.t("changePermissions")))]
                                )
                              : _c(
                                  "v-btn",
                                  {
                                    staticClass: "ma-0 pa-0 ml-2",
                                    attrs: {
                                      id: "blue_btn",
                                      loading: _vm.loading,
                                      width: "10rem",
                                      height: "2rem",
                                    },
                                    on: { click: _vm.addUserGroupAuthGroup },
                                  },
                                  [_vm._v(_vm._s(_vm.t("createPermissions")))]
                                ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]
            },
            proxy: true,
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }